import React from 'react'
import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'
import ConsentFormItem, { ConsentFormData } from './ConsentFormItem'
import { commonPatterns } from 'utils/enhancedTestIds'

interface ConsentFormsListProps {
  items: ConsentFormData[]
  residentId: string
  testId?: string
}

const ConsentFormsList: React.FC<ConsentFormsListProps> = ({
  items,
  residentId,
  testId
}) => {
  const navigate = useNavigate()

  if (!items?.length) {
    return null
  }

  const handleItemClick = (consentId: string) => {
    navigate(`/residents/${residentId}/consent/${consentId}`)
  }

  return (
    <Wrapper data-testid={testId}>
      <ItemsWrapper>
        {items.map((item, index) => (
          <ConsentFormItem
            key={item.id}
            data={item}
            testId={testId ? commonPatterns.row(testId, index) : undefined}
            onClick={() => handleItemClick(item.id)}
          />
        ))}
      </ItemsWrapper>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

const ItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export default ConsentFormsList
